// extracted by mini-css-extract-plugin
export var cartContainer = "_pl-4";
export var gray = "_pl-1";
export var itemContainer = "_pl-2";
export var itemDetails = "_pl-3";
export var strong = "_pl-0";